import axios from 'axios';

export const TEAMS_RECEIVED = 'TEAMS_RECEIVED';

const getTeams = (ignore = false) => {
    if (ignore) {
        return () => {};
    }
    return dispatch => (
        axios.get('/api/teams')
        .then((response) => {
            dispatch({
                type: TEAMS_RECEIVED,
                all: response.data.data.all,
                userTeams: response.data.data.userTeams,
                currentTeam: response.data.data.currentTeam,
            });
        })
        .catch((error) => {
            if (error.response && error.response.status === 401) {
                //fail silently if the user is not logged in
            } else {
                throw (error);
            }
        })
    );
};

export default getTeams;
